import type { KLineData } from 'klinecharts'

export type Field = 'open' | 'high' | 'low' | 'close' | 'volume'

/** One OHLCV column as a Float64Array (missing volume reads as 0). */
export function column(bars: readonly KLineData[], field: Field): Float64Array {
  const out = new Float64Array(bars.length)
  for (let i = 0; i < bars.length; i++) {
    const v = bars[i][field]
    out[i] = typeof v === 'number' ? v : field === 'volume' ? 0 : NaN
  }
  return out
}

export const nanArray = (n: number): Float64Array => new Float64Array(n).fill(NaN)

/** TA_EPSILON as defined in ta_utility.h at tag v0.6.4 (1e-14; TA-Lib 0.4 used 1e-8). */
export const TA_EPSILON = 0.00000000000001
/** TA_IS_ZERO — every TA-Lib divide guard uses this, never `=== 0`. */
export const isZero = (x: number): boolean => x > -TA_EPSILON && x < TA_EPSILON
/** TA_IS_ZERO_OR_NEG */
export const isZeroOrNeg = (x: number): boolean => x < TA_EPSILON

/** Element-wise a − b (NaN propagates, like numpy). */
export function sub(a: Float64Array, b: Float64Array): Float64Array {
  const out = new Float64Array(a.length)
  for (let i = 0; i < a.length; i++) out[i] = a[i] - b[i]
  return out
}

/** `src` with everything before `from` set to NaN. */
export function maskBefore(src: Float64Array, from: number): Float64Array {
  const out = src.slice()
  for (let i = 0; i < Math.min(from, out.length); i++) out[i] = NaN
  return out
}
